export default "__VITE_ASSET__CCC9VlS7__"